// Centralized offer utilities for time-bound promotions
// Diwali offer: Regular Plan (12-24 Hours) discounted from 599 to 499 until Oct 31 (inclusive)

export function isDiwaliOfferActive(now = new Date()) {
  try {
    const year = now.getFullYear();
    // Offer window: Oct 1 00:00:00 to Oct 31 23:59:59 local time
    const start = new Date(year, 9, 1, 0, 0, 0, 0);   // month is 0-indexed; 9 = October
    const end = new Date(year, 9, 31, 23, 59, 59, 999);
    return now >= start && now <= end;
  } catch (_) {
    return false;
  }
}

export function getRegularPlanEffectivePrice(basePrice = 599, now = new Date()) {
  return isDiwaliOfferActive(now) ? 499 : basePrice;
}

export function getRegularPlanDiscountPerNight(now = new Date()) {
  return isDiwaliOfferActive(now) ? 100 : 0; // ₹100 off per bed per night during offer
}

export function isRegularPlan(pkg) {
  return pkg?.plan === 'Regular Plan' || pkg?.name === 'Regular Plan';
}

export function isRegular12to24(pkgOrLabel) {
  if (!pkgOrLabel) return false;
  if (typeof pkgOrLabel === 'string') return pkgOrLabel.includes('12-24');
  const label = pkgOrLabel.duration || pkgOrLabel.label;
  return typeof label === 'string' && label.includes('12-24');
}
